import Swiper from 'swiper';

const initSliderValuation = (id: string): Swiper => (
  new Swiper(`${id} .swiper`, {
    speed: 600,
    simulateTouch: false
  })
);

export default initSliderValuation;
